import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
  useMemo,
} from "react";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import OptionChainModal from "../../modals/OptionChainModal";
import { useLtpContext } from "../../context/LtpContext";
import WebsocketWrapperContext from "../../context/WebsocketWrapperContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomToastContent from "../../components/CustomToastContent";
import SuccessIcon from "../../images/success_icon.svg";
import ErrorIcon from "../../images/error_icon.svg";
import { useFundsData } from "../../context/FundsDataContext";
import MetricsComputations from "../../components/MetricsComputations";
import GraphMetricsComputations from "../../components/GraphMetricsComputations";
import { ButtonContext } from "../../context/ButtonsContext";
import "../../css/buttonmodal.css";
import { useNavigate, useLocation } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useTheme } from "../../context/ThemeContext";
import { useOverlay } from "../../context/OverlayContext";
import { strategies } from "../../utils/strategies";
import OcIcon from "../../images/Builder/option_chain.svg";
import AutoFindIcon from "../../images/Builder/auto_find.svg";
import Tabs from "./components/Tabs";
import Basket from "./components/Basket";
import { useApplyPreBuiltStrategy } from "./helpers/ApplyPrebuilt";
import PrebuiltStrategies from "./components/PrebuiltStrategies";
import { useBuilderContext } from "./context/BuilderContext";
import MarginAndFundsCard from "./components/MarginAndFundsCard";
import StrategyMenu from "../../components/StrategyMenu";
import { formatNumberWithCommasAndFontWeight } from "./helpers/formatNumber";
import ConfirmStrategyModal from "./components/ComfirmModal";
import generateOrderPayload from "./helpers/generate_orders_payload";
import sendOrder from "./helpers/send_order";
import ScreenerModal from "./components/ScreenerModal";
import PayoffGraph from "../Payoff/PayoffGraph";
import OptionChainTable from "../../components/OptionChainTable";
import ExpiryDropdown from "../OptionChainScreen/components/ExpiryDropdown";
import Configure from "../OptionChainScreen/components/Configure";
import HedgeStratgiesContainer from "./components/HedgeStratgiesContainer";
import InstrumentTypeToggle from "./components/InstrumentTypeToggle";
import FuturesTable from "./components/FuturesTable";
import Cross from "../../images/Builder/cross.svg";
import CrossDark from "../../images/Builder/cross_dark.svg";
import BuySellModal from "../../modals/BuySellModal";
import { useBuySellModalContext } from "../../context/BuySellModalContext";
import { getCookie } from "../../utils/cookieUtils";
let triggerSubscribe = true;
let connectionEstablised = false;

const StrategyCreatorDesktop = () => {
  const { applyPreBuiltStrategy, applyHedgeStrategy } =
    useApplyPreBuiltStrategy();
  const {
    setRows,
    selectedSymbol,
    selectedData,
    symbolsActiveCategory,
    symbolsSelectedStrategy,
    setSymbolsSelectedStrategy,
    allOptionsData,
    setLimitOrderStates,
    handleLotxChange,
    handleMarketTypeChange,
    marketType,
    limitOrderStates,
    clearBasket,
    selectedExpiry,
    currentOptionsData,
    rows,
    configureSettingsMap,
    setConfigureSettingsMap,
    setSelectedExpiry,
    getProcessedSymbolData,
    normalizeExpiryDate,
  } = useBuilderContext();
  const { theme } = useTheme();
  const [showConfirm, setShowConfirm] = useState(false);
  const { isOverlayActive, showOverlay, hideOverlay } = useOverlay();
  const [showCalls, setShowCalls] = useState(true);
  const [showPuts, setShowPuts] = useState(true);
  const [currentOptionsCopy, setCurrentOptionsCopy] = useState({});
  const [symbols, setSymbols] = useState([]);
  const [optionData, setOptionData] = useState(null);
  const [tempOptionData, setTempOptionData] = useState({});
  const [allOptionData, setAllOptionData] = useState({});
  const [allTradingSymbols, setAllTradingSymbols] = useState({});
  const [selectedData1, setData] = useState([]);
  const [activeDate, setActiveDate] = useState("");
  const [activeCategory, setActiveCategory] = useState("bullish");

  const [openModal, setOpenModal] = useState(false);
  const [inputValues, setInputValues] = useState([]);
  const [calls, setCalls] = useState([]);
  const [puts, setPuts] = useState([]);
  const [showDelta, setShowDelta] = useState(false);
  const [showTheta, setShowTheta] = useState(false);
  const [showGamma, setShowGamma] = useState(false);
  const [showVega, setShowVega] = useState(false);
  const [showRho, setShowRho] = useState(false);
  const [showOIChng, setShowOIChng] = useState(false);
  const [showOIBuilddup, setShowOIBuilddup] = useState(false);
  const [support, setSupport] = useState(0);
  const [resistance, setResistance] = useState(0);
  const [maxPain, setMaxPain] = useState(0);
  const [trend, setTrend] = useState({});
  const [rotate, setRotate] = useState(false);
  const [greeksJson, setGreeksJson] = useState([]);
  const [isBuySellModalOpen, setIsBuySellModalOpen] = useState(false);
  const [modalAction, setModalAction] = useState("add");

  const [orderTypes, setOrderTypes] = useState({});
  const [inputModes, setInputModes] = useState({});

  const [selectedInstrumentType, setSelectedInstrumentType] =
    useState("Options"); // Add this state
  const [futuresExpiries, setFuturesExpiries] = useState([]); // Add this for futures expiries
  const [futuresData, setFuturesData] = useState(null); // Add this for futures data
  const [showOptionChainModal, setShowOptionChainModal] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const {
    checkWebsocketConnection,
    subscribeToSymbols,
    unsubscribeToSymbols,
    symbolList,
    symbolData,
  } = useContext(WebsocketWrapperContext);
  const { fundsData, fetchBalanceAPI } = useFundsData();
  const broker = localStorage.getItem("broker");
  const access_token = getCookie("access_token");
  const client_id = getCookie("client_id");
  var iv = require("implied-volatility");
  var greeks = require("greeks");
  const { buySellModalData, setBuySellModalData } = useBuySellModalContext();

  const metricsComputations = MetricsComputations();
  const graphMetricsComputations = GraphMetricsComputations();

  const [computedData, setComputedData] = useState();
  const [graphComputedData, setGraphComputedData] = useState();
  const [hasUnlimitedMaxLoss, setHasUnlimitedMaxLoss] = useState(false);
  // // console.log(rows);

  const handleToastToNavigate = (response) => {
    navigate(response.page);
    // // console.log("Clicked");
  };
  useEffect(() => {
    connectionEstablised = checkWebsocketConnection();
    if (connectionEstablised && symbols.length > 0) {
      if (triggerSubscribe) {
        subscribeToSymbols(symbols, "NSE");
        if (Object.keys(symbolList).length !== 0) {
          triggerSubscribe = false;
        }
      }
    } else {
      triggerSubscribe = true;
    }
  }, [symbolData]);

  const getCodeTradingSymbolMappings = (data, key) => {
    const codeTradingSymbol = [];
    for (const item of data) {
      const { code } = item[key];
      codeTradingSymbol.push(code);
    }
    return codeTradingSymbol;
  };

  useEffect(() => {
    if (
      currentOptionsData[selectedExpiry] &&
      currentOptionsData[selectedExpiry].options
    ) {
      let callsdata = currentOptionsData[selectedExpiry].options.map(
        (option) => option.call
      );
      let putsdata = currentOptionsData[selectedExpiry].options.map(
        (option) => option.put
      );
      setCalls(callsdata);
      setPuts(putsdata);
      const call = getCodeTradingSymbolMappings(
        currentOptionsData[selectedExpiry].options,
        "call"
      );
      const put = getCodeTradingSymbolMappings(
        currentOptionsData[selectedExpiry].options,
        "put"
      );
      const tradingSymbols = call.concat(put);
      subscribeToSymbols(
        tradingSymbols,
        currentOptionsData[selectedExpiry].options[0]?.call?.exchange
      );
    }
  }, [currentOptionsData[selectedExpiry]]);

  useEffect(() => {
    if (optionData && optionData.options) {
      const strikeOpenInterest = {};
      let callMaxOi = 0;
      let putMaxOi = 0;
      let support = 0;
      let resistance = 0;
      // Iterate through the options array and accumulate open interest
      optionData.options.forEach((option) => {
        const callOi = parseFloat(symbolData[option.call.code]?.oi);
        const putOi = parseFloat(symbolData[option.put.code]?.oi);
        let spot = parseFloat(symbolData[selectedSymbol?.code]?.ltp);
        if (callOi > callMaxOi && spot < parseFloat(option.strike)) {
          callMaxOi = callOi;
          resistance = option.strike;
        }
        if (putOi > putMaxOi && spot > parseFloat(option.strike)) {
          putMaxOi = putOi;
          support = option.strike;
        }
        if (!strikeOpenInterest[option.call.strike]) {
          strikeOpenInterest[option.call.strike] = { callOi: 0, putOi: 0 };
        }

        strikeOpenInterest[option.call.strike].callOi += callOi;
        strikeOpenInterest[option.call.strike].putOi += putOi;
      });
      setResistance(resistance);
      setSupport(support);
      let maxPainStrike = null;
      let maxTotalOi = 0;

      for (const strike in strikeOpenInterest) {
        const { callOi, putOi } = strikeOpenInterest[strike];
        const totalOi = callOi + putOi;

        if (totalOi > maxTotalOi) {
          maxTotalOi = totalOi;
          maxPainStrike = strike;
        }
      }
      if (maxPainStrike) {
        setMaxPain(maxPainStrike);
      }
    }
  }, [optionData, symbolData, maxPain]);

  const lastLtpRef = useRef();

  useEffect(() => {
    const currentLtp = symbolData[selectedSymbol?.code]?.ltp;
    if (selectedData?.length === 0) {
      setComputedData(null);
      setGraphComputedData(null);
      setHasUnlimitedMaxLoss(false); // Reset when no data
    }
    if (
      selectedData?.length > 0 &&
      selectedSymbol &&
      selectedSymbol.option_expiries?.length > 0 &&
      currentOptionsData[selectedExpiry]?.options?.[0]?.call
    ) {
      lastLtpRef.current = currentLtp;
      const transformedSelectedData = [];
      selectedData.forEach((row) => {
        const lotSize = Math.abs(row.lotSize);

        if (row.isFuture) {
          // For futures, treat as a single instrument with linear payoff
          transformedSelectedData.push({
            ...row,
            strike: row.price, // Use entry price as strike for futures
            price: row.price,
            isFuture: true,
          });
        } else {
          transformedSelectedData.push({
            ...row,
          });
        }
      });
      const fetchData = async () => {
        try {
          const metrics = await metricsComputations.computeXandYAxis({
            transformedSelectedData,
            ltp: currentLtp,
            symbol: selectedSymbol,
            leastExpiry: selectedSymbol.option_expiries[0],
            lotsVal:
              currentOptionsData[selectedExpiry].options[0].call.lot_size,
            currentOptionsData: currentOptionsData,
            selectedExpiry: selectedExpiry,
          });
          const graphMetrics = await graphMetricsComputations.computeXandYAxis({
            transformedSelectedData,
            ltp: currentLtp,
            symbol: selectedSymbol,
            leastExpiry: selectedSymbol.option_expiries[0],
            lotsVal:
              currentOptionsData[selectedExpiry].options[0].call.lot_size,
            currentOptionsData: currentOptionsData,
            selectedExpiry: selectedExpiry,
          });
          setComputedData(metrics);
          setGraphComputedData(graphMetrics);

          // Check if max loss is unlimited
          const isUnlimited =
            metrics?.maxLoss === Infinity ||
            metrics?.maxLoss === -Infinity ||
            metrics?.maxLoss === "Unlimited";
          setHasUnlimitedMaxLoss(isUnlimited);
        } catch (error) {
          console.error("Error computing metrics:", error.message);
          setHasUnlimitedMaxLoss(false); // Reset on error
        }
      };

      fetchData();
    }
  }, [selectedData, selectedSymbol, selectedExpiry]);

  // Keep expiry list aligned with selected instrument type
  useEffect(() => {
    if (!selectedSymbol) return;
    if (selectedInstrumentType === "Futures") {
      const futExp = selectedSymbol?.fut_expiries || [];
      setFuturesExpiries(futExp);
      // Always reset to the first futures expiry when switching to Futures
      if (futExp.length > 0) {
        setSelectedExpiry(futExp[0]);
      }
    } else {
      const optExp = selectedSymbol?.option_expiries || [];
      // Always reset to the first options expiry when switching to Options
      if (optExp.length > 0) {
        setSelectedExpiry(optExp[0]);
      }
    }
  }, [selectedInstrumentType]);

  // Prepare futures table data and subscribe for live updates
  useEffect(() => {
    try {
      if (
        selectedInstrumentType !== "Futures" ||
        !selectedSymbol ||
        !selectedExpiry ||
        futuresExpiries.length === 0
      ) {
        setFuturesData([]);
        return;
      }

      const processed = getProcessedSymbolData?.(selectedSymbol.scrip);
      if (!processed) {
        setFuturesData([]);
        return;
      }

      const normalizedSelected = normalizeExpiryDate?.(selectedExpiry);
      const expiryKey =
        Object.keys(processed).find(
          (k) => (normalizeExpiryDate?.(k) || k) === normalizedSelected
        ) || selectedExpiry;

      const futuresList = processed?.[expiryKey]?.futures || [];
      if (!Array.isArray(futuresList) || futuresList.length === 0) {
        setFuturesData([]);
        return;
      }

      const futCodes = futuresList.map((f) => f.code).filter(Boolean);
      if (futCodes.length > 0) {
        subscribeToSymbols(
          futCodes,
          futuresList[0]?.exchange || selectedSymbol.exchange || "NSE"
        );
      }

      const tableData = futuresList.map((fut) => ({
        scrip:
          fut.trading_symbol || fut.instrument_name || selectedSymbol.scrip,
        ltp: symbolData?.[fut.code]?.ltp ?? "-",
        oi: symbolData?.[fut.code]?.oi ?? "-",
        volume:
          symbolData?.[fut.code]?.volume ?? symbolData?.[fut.code]?.vol ?? "-",
        raw: fut,
        change_per:
          symbolData?.[fut.code]?.change_per ??
          symbolData?.[fut.code]?.change_per ??
          "-",
        previous_oi:
          symbolData?.[fut.code]?.previous_oi ??
          symbolData?.[fut.code]?.previous_oi ??
          "-",
      }));

      setFuturesData(tableData);
    } catch (e) {
      console.error("Error preparing futures data:", e);
      setFuturesData([]);
    }
  }, [selectedInstrumentType, selectedSymbol, selectedExpiry, symbolData]);

  // Add this useEffect to reset futures data when selectedSymbol changes
  useEffect(() => {
    if (showOptionChainModal && selectedSymbol) {

      setFuturesExpiries([]);
      setFuturesData([]);

      // Resetting to Options
      setSelectedInstrumentType("Options");

      const optExpiries = selectedSymbol?.option_expiries || [];
      if (optExpiries.length > 0) {
        setSelectedExpiry(optExpiries[0]);
      }
    }
  }, [showOptionChainModal, selectedSymbol]);

  const handleStrategySelect = (strategyId) => {
    scrollToTop();
    handleLotxChange(1);
    handleMarketTypeChange("NRML");
    setLimitOrderStates((prev) => ({
      ...prev,
      [selectedSymbol?.scrip]: [],
    }));
    const currentStrategy = symbolsSelectedStrategy[selectedSymbol.scrip];
    if (currentStrategy === strategyId) {
      setSymbolsSelectedStrategy((prev) => ({
        ...prev,
        [selectedSymbol.scrip]: null,
      }));
      if (selectedData?.length > 0) {
        setRows((prev) => ({
          ...prev,
          [selectedSymbol?.scrip]: [],
        }));
      }
      return;
    }
    setSymbolsSelectedStrategy((prev) => ({
      ...prev,
      [selectedSymbol.scrip]: strategyId,
    }));
    const childData = applyPreBuiltStrategy(strategyId);
    handleCallback([childData], false);
  };

  const handleHedgeStrategySelect = (strategyId) => {
    handleLotxChange(1);
    handleMarketTypeChange("NRML");
    setLimitOrderStates((prev) => ({
      ...prev,
      [selectedSymbol?.scrip]: [],
    }));
    const currentStrategy = symbolsSelectedStrategy[selectedSymbol.scrip];
    if (currentStrategy === strategyId) {
      setSymbolsSelectedStrategy((prev) => ({
        ...prev,
        [selectedSymbol.scrip]: null,
      }));
      if (selectedData?.length > 0) {
        setRows((prev) => ({
          ...prev,
          [selectedSymbol?.scrip]: [],
        }));
      }
      return;
    }
    setSymbolsSelectedStrategy((prev) => ({
      ...prev,
      [selectedSymbol.scrip]: strategyId,
    }));
    const childData = applyHedgeStrategy(strategyId);
    handleCallback([childData], false);
  };

  // Open Buy/Sell modal for a futures instrument
  const openBuySellModalForFuture = (fut, buyOrSell) => {
    if (!fut) return;
    const ltpPrice = symbolData?.[fut.code]?.ltp || 0;
    const data_object = {
      side: "Future",
      instrumentName: fut.instrument_name,
      lotSize: 1,
      lot_size: parseFloat(fut.lot_size) || 1,
      optionType: "FUT",
      tradingSymbol: fut.trading_symbol,
      expiryDate: fut.expiry_date,
      code: fut.code,
      price: ltpPrice || 0,
      trigger_price: ltpPrice || 0,
      buy_sell: buyOrSell === "Buy" ? "B" : "S",
      strike: "FUTURE",
      quantity: 1,
      freeze_qty: fut.freeze_qty,
      exchange: fut.exchange,
      lot_multiplier: parseFloat(fut.lot_size) || 1,
      scrip: selectedSymbol?.scrip,
      isFuture: true,
    };
    setBuySellModalData([data_object]);
    setModalAction("add");
    setIsBuySellModalOpen(true);
  };

  // Called by BuySellModal when clicking "Add to Basket"
  const handleFuturesAddToBasket = () => {
    if (!Array.isArray(buySellModalData) || !buySellModalData[0]) return;
    const d = buySellModalData[0];
    const futureInstrument = {
      buy_sell: d.buy_sell === "B" ? "Buy" : "Sell",
      code: d.code,
      expiryDate: d.expiryDate,
      instrumentName: d.instrumentName,
      lotSize: d.lotSize || 1,
      side: "Future",
      tradingSymbol: d.tradingSymbol,
      quantity: d.lotSize || 1,
      strike: "FUTURE",
      freeze_qty: d.freeze_qty,
      exchange: d.exchange,
      lot_multiplier: parseFloat(d.lot_multiplier) || 1,
      isFuture: true,
      scrip: d.scrip,
      price: d.price,
      trigger_price: d.trigger_price,
    };
    handleCallback([[futureInstrument]], false);;
  };

  function getDifference(value1, value2) {
    return Math.abs(value1 - value2);
  }

  // const handleScreenerback = async (rowData) => {
  //   setSymbolsSelectedStrategy((prev) => ({
  //     ...prev,
  //     [selectedSymbol.scrip]: null,
  //   }));
  //   let filtered_rows = [];
  //   rowData.map((item, index) => {
  //     if (item.hasTick) {
  //       let row = item.data;
  //       let targetValue = row.inputValue;
  //       if (
  //         row.selectedCondition == "delta" ||
  //         row.selectedCondition == "theta" ||
  //         row.selectedCondition == "gamma" ||
  //         row.selectedCondition == "vega"
  //       ) {
  //         targetValue = targetValue / 100;
  //         let closestJson = currentOptionsData[selectedExpiry].options.reduce(
  //           (prev, curr) => {
  //             let prev_data = row.isCALL ? prev.call : prev.put;
  //             let curdd_data = row.isCALL ? curr.call : curr.put;
  //             const prevDiff = getDifference(
  //               Math.abs(prev_data.delta),
  //               targetValue
  //             );
  //             const currDiff = getDifference(
  //               Math.abs(curdd_data.delta),
  //               targetValue

  //             );
  //             return currDiff < prevDiff ? curr : prev;
  //           }
  //         );
  //         let selected_row = row.isCALL ? closestJson.call : closestJson.put;

  //         let addingRow = {
  //           buy_sell: row.isBuy ? "Buy" : "Sell",
  //           code: selected_row.code,
  //           expiryDate: selected_row.expiry_date,
  //           instrumentName: selected_row.instrument_name,
  //           lotSize: selected_row.lot_size,
  //           side: row.isCALL ? "Call" : "Put",
  //           tradingSymbol: selected_row.trading_symbol,
  //           quantity: row.lotsValue,
  //           freeze_qty: selected_row.freeze_qty,
  //           exchange: selected_row.exchange,
  //           strike: parseInt(selected_row.strike),
  //           lot_multiplier: selected_row.lot_size,
  //         };
  //         filtered_rows.push(addingRow);
  //       }
  //     }
  //   });
  //   if (filtered_rows.length > 0) {
  //     handleCallback([filtered_rows]);
  //     toast.info(
  //       <CustomToastContent
  //         heading="Instruments identified successfully!"
  //         message="Instrument added to the basket and analytics updated successfully."
  //       />,
  //       {
  //         className: "custom-success-toast",
  //         icon: <img src={SuccessIcon} alt="Success Icon" />,
  //       }
  //     );
  //   } else {
  //     toast.error(
  //       <CustomToastContent
  //         heading="Instruments not found!"
  //         message="Instruments with required combinations not found, please add from option chain"
  //       />,
  //       {
  //         className: "custom-error-toast",
  //         icon: <img src={ErrorIcon} alt="Error Icon" />,
  //       }
  //     );
  //   }
  // };

  useEffect(() => {
    if (
      currentOptionsData[selectedExpiry] &&
      currentOptionsData[selectedExpiry]["options"]?.length > 0 &&
      symbolData[selectedSymbol?.code]
    ) {
      let underlying_ltp = symbolData[selectedSymbol?.code]?.ltp;
      let data = { ...currentOptionsData[selectedExpiry] };
      const formattedData = data["options"]?.map((item) => ({
        ...item,
        strike: parseInt(item.strike),
      }));

      let minDiff = Math.abs(
        formattedData[0]?.strike - parseFloat(underlying_ltp)
      );
      let closestIdx = 0;

      // Iterate through the array to find the closest index
      formattedData.forEach((item, index) => {
        const diff = Math.abs(item.strike - parseFloat(underlying_ltp));
        if (diff < minDiff) {
          minDiff = diff;
          closestIdx = index;
        }
      });
      const userSelectedStrikes = configureSettingsMap.noOfStrikes;
      const half = Math.floor(userSelectedStrikes / 2);
      // const half = Math.floor(configureSettingsMap.noOfStrikes);
      // console.log(half);
      const selected = formattedData.slice(
        Math.max(0, closestIdx - half),
        Math.min(formattedData.length, closestIdx + half)
      );
      data["options"] = selected;
      setOptionData(data);
      // setTempOptionData(data);

      let callsdata = data?.options?.map((option) => option?.call);
      let putsdata = data?.options?.map((option) => option?.put);
      setCalls(callsdata);
      setPuts(putsdata);
    }
  }, [configureSettingsMap.noOfStrikes, selectedExpiry]);

  const handleScreenerback = async (rowData) => {
    setSymbolsSelectedStrategy((prev) => ({
      ...prev,
      [selectedSymbol.scrip]: null,
    }));

    let filtered_rows = [];

    rowData.forEach((item) => {
      if (item.hasTick) {
        let row = item.data;
        let targetValue = row.inputValue;

        const greek = row.selectedCondition;
        const validGreeks = ["delta", "theta", "gamma", "vega", "rho"];

        if (validGreeks.includes(greek)) {
          targetValue = targetValue / 100;

          let closestJson = currentOptionsData[selectedExpiry].options.reduce(
            (prev, curr) => {
              const type = row.isCALL ? "call" : "put";

              const prevData = prev?.[type];
              const currData = curr?.[type];

              const prevValue = prevData?.[greek];
              const currValue = currData?.[greek];

              const prevDiff =
                prevValue !== undefined
                  ? Math.abs(Math.abs(prevValue) - targetValue)
                  : Number.POSITIVE_INFINITY;
              const currDiff =
                currValue !== undefined
                  ? Math.abs(Math.abs(currValue) - targetValue)
                  : Number.POSITIVE_INFINITY;

              return currDiff < prevDiff ? curr : prev;
            }
          );

          let selected_row = row.isCALL ? closestJson.call : closestJson.put;

          let addingRow = {
            buy_sell: row.isBuy ? "Buy" : "Sell",
            code: selected_row.code,
            expiryDate: selected_row.expiry_date,
            instrumentName: selected_row.instrument_name,
            lotSize: selected_row.lot_size,
            side: row.isCALL ? "Call" : "Put",
            tradingSymbol: selected_row.trading_symbol,
            quantity: row.lotsValue,
            freeze_qty: selected_row.freeze_qty,
            exchange: selected_row.exchange,
            strike: parseInt(selected_row.strike),
            lot_multiplier: selected_row.lot_size,
          };

          filtered_rows.push(addingRow);
        }
      }
    });

    if (filtered_rows.length > 0) {
      handleCallback([filtered_rows]);
      toast.info(
        <CustomToastContent
          heading="Instruments identified successfully!"
          message="Instrument added to the basket and analytics updated successfully."
        />,
        {
          className: "custom-info-toast",
          icon: <img src={SuccessIcon} alt="Success Icon" />,
        }
      );
    } else {
      toast.error(
        <CustomToastContent
          heading="Instruments not found!"
          message="Instruments with required combinations not found, please add from option chain"
        />,
        {
          className: "custom-error-toast",
          icon: <img src={ErrorIcon} alt="Error Icon" />,
        }
      );
    }
  };

  const callBackToUpdateAlloption = (newOptions) => {
    let date = newOptions?.options[0]?.call?.expiry_date;
    let optdt = newOptions;
    setAllOptionData((prevStatus) => ({
      ...prevStatus,
      [date]: optdt,
    }));
  };

  // Function to find ATM (At The Money) index
  const returnAtmIndex = () => {
    let index = 0;
    const ltp = symbolData[selectedSymbol?.code]?.ltp || 0;

    if (
      currentOptionsData[selectedExpiry] &&
      currentOptionsData[selectedExpiry].options &&
      currentOptionsData[selectedExpiry].options?.length > 0
    ) {
      let optionData = currentOptionsData[selectedExpiry].options;
      let curr = parseFloat(optionData[0].strike);
      let diff = Math.abs(ltp - curr);

      for (let val = 0; val < optionData.length; val++) {
        const strike = parseFloat(optionData[val].strike);
        const newDiff = Math.abs(ltp - strike);

        if (newDiff < diff) {
          diff = newDiff;
          curr = strike;
          index = val;
        }
      }
    }
    return index;
  };

  // Function to construct instruments for hedging
  const constructHedgeInstruments = (
    call_put_array,
    buy_sell_array,
    index_array,
    quantity_array
  ) => {
    let row_list = [];

    for (let index = 0; index < call_put_array.length; index++) {
      let atmIndex = index_array[index];

      // Safety check for index
      if (atmIndex < 0) atmIndex = 0;
      if (atmIndex >= currentOptionsData[selectedExpiry].options?.length)
        atmIndex = currentOptionsData[selectedExpiry].options?.length - 1;

      const side = call_put_array[index];
      const option =
        side === "Call"
          ? currentOptionsData[selectedExpiry].options[atmIndex].call
          : currentOptionsData[selectedExpiry].options[atmIndex].put;

      row_list.push({
        buy_sell: buy_sell_array[index],
        code: option.code,
        expiryDate: option.expiry_date,
        instrumentName: option.instrument_name,
        lotSize: option.lot_size,
        side: side,
        tradingSymbol: option.trading_symbol,
        quantity: quantity_array[index],
        strike: option.strike,
        freeze_qty: option.freeze_qty,
        exchange: option.exchange,
        lot_multiplier: parseFloat(
          option.lot_size || currentOptionsData[selectedExpiry].lot_size
        ),
        isFuture: false,
      });
    }

    return row_list;
  };

  // Function to add hedge rows to limit risk for unlimited max loss strategies
  const addHedge = () => {
    if (!selectedData || selectedData.length === 0) {
      toast.error(
        <CustomToastContent
          heading="No positions to hedge"
          message="Please add some positions to the basket first."
        />,
        {
          className: "custom-error-toast",
          icon: <img src={ErrorIcon} alt="Error Icon" />,
        }
      );
      return;
    }

    if (!currentOptionsData || !currentOptionsData[selectedExpiry]) {
      toast.error(
        <CustomToastContent
          heading="Option data not available"
          message="Please wait for option chain data to load."
        />,
        {
          className: "custom-error-toast",
          icon: <img src={ErrorIcon} alt="Error Icon" />,
        }
      );
      return;
    }

    let call_put_array = [];
    let select_index = [];
    let lots_array = [];
    let hedge_buy = [];

    // Get ATM index for hedging calculations
    const atmIndex = returnAtmIndex();

    // Iterate through selectedData to find sell positions
    for (let index = 0; index < selectedData.length; index++) {
      const row = selectedData[index];

      // Check if this is a sell position (isBuy == false)
      if (row.isBuy === false) {
        let selected_strike = 0;
        const lots = row.lotSize;

        if (row.isCALL) {
          // For sell call, buy call at ATM + 15 strikes
          selected_strike = atmIndex + 15;
          call_put_array.push("Call");
        } else {
          // For sell put, buy put at ATM - 15 strikes
          selected_strike = atmIndex - 15;
          call_put_array.push("Put");
        }

        select_index.push(selected_strike);
        lots_array.push(lots);
        hedge_buy.push("Buy");
      }
    }

    // If no sell positions found, return early
    if (call_put_array.length === 0) {
      toast.info(
        <CustomToastContent
          heading="No sell positions to hedge"
          message="Only sell positions require hedging to limit risk."
        />,
        {
          className: "custom-info-toast",
          icon: <img src={SuccessIcon} alt="Success Icon" />,
        }
      );
      return;
    }

    // Construct hedge instruments
    const childData = constructHedgeInstruments(
      call_put_array,
      hedge_buy,
      select_index,
      lots_array
    );

    // Add hedge rows to basket
    handleCallback([childData], true);

    toast.success(
      <CustomToastContent
        heading="Hedge added successfully!"
        message={`Added ${childData.length} hedge instrument(s) to limit risk.`}
      />,
      {
        className: "custom-success-toast",
        icon: <img src={SuccessIcon} alt="Success Icon" />,
      }
    );
  };

  const handleCallback = async ([rowData], should_add) => {
    let rows = [];
    for (let index = 0; index < rowData?.length; index++) {
      let childData = rowData[index];
      let dataToAdd = childData;
      await subscribeToSymbols([childData.code], childData.exchange);
      let dt = dataToAdd.instrumentName.split(" ");
      let date = dataToAdd.expiryDate;
      const dDate = date.replaceAll("%20", " ");
      const newObject = {
        isBuy: childData.buy_sell == "Buy" ? true : false,
        isCALL: childData.side == "Call" ? true : false,
        strike: parseInt(childData.strike),
        expiry: dDate,
        scrip: dt[0],
        lotSize: childData.quantity,
        code: childData.code,
        tradingSymbol: childData.tradingSymbol,
        allstrks: [],
        allData: [],
        freeze_qty: childData.freeze_qty,
        exchange: childData.exchange,
        lot_multiplier: childData.lot_multiplier,
        instrumentName: childData?.instrumentName,
        orderType: "MARKET",
        price: "",
        stoploss: "", // Default empty stoploss
        target: "", // Default empty target
        isSelected: true,
        isEdit: false,
        productType: "NRML",
        isNewRow: true,
        isFuture: childData.isFuture,
      };
      const newobj = [newObject.code];
      setSymbols(newobj);

      const formattedDate = newObject.expiry.replaceAll(" ", "%20");
      let alldt;
      alldt = allOptionsData[selectedSymbol.scrip][newObject.expiry];

      setTimeout(() => {
        let allstrk = extractStrikeValues(alldt);
        newObject.allstrks = allstrk;
        newObject.allData = alldt?.options;
      }, 200);
      rows.push(newObject);
    }
    const scrip = selectedSymbol.scrip;
    setRows((prev) => {
      const existing = prev[scrip] || [];
      const updatedRows = should_add ? [...existing, ...rows] : rows;
      return {
        ...prev,
        [scrip]: updatedRows,
      };
    });
  };

  const handleCallback2 = async ([childData, buy_sell]) => {
    // Update the name in the component's state
    let dataToAdd = childData;
    let dt = dataToAdd.instrumentName.split(" ");
    let date = dataToAdd.expiryDate;
    const dDate = date.replaceAll("%20", " ");
    const newObject = {
      isBuy: buy_sell == "B" ? true : false,
      isCALL: childData.side == "Call" ? true : false,
      strike: parseInt(childData.strike),
      scrip: dt[0],
      lotSize: childData.lotSize,
      code: childData.code,
      tradingSymbol: childData.tradingSymbol,
      allstrks: [],
      allData: [],
      freeze_qty: childData.freeze_qty,
      exchange: childData.exchange,
      lot_multiplier: childData.lot_multiplier,
      strike: childData.strike,
      expiry: childData.expiryDate,
      tradingSymbol: childData.tradingSymbol,
      lot_multiplier: childData.lot_multiplier,
      scrip: childData.scrip,
      price: childData?.price,
      stoploss: childData?.stoploss || "", // Default empty stoploss
      target: childData?.target || "", // Default empty target
      orderType: childData?.orderType,
    };
    // // console.log(newObject);
    setObjectData(newObject);
    const newobj = [newObject.code];
    setSymbols(newobj);
    // updateSymbol();
    const formattedDate = newObject.expiry.replaceAll(" ", "%20");
    let alldt;
    if (optionData?.id !== selectedSymbol.scrip + newObject.expiry) {
      alldt = allOptionsData[selectedSymbol.scrip][newObject.expiry];
    }
    setTimeout(() => {
      let allstrk = extractStrikeValues(alldt);
      newObject.allstrks = allstrk;
      newObject.allData = alldt?.options;
      const scrip = selectedSymbol.scrip;
      setRows((prev) => {
        const existing = prev[scrip] || [];
        const updatedRows = [...existing, newObject];
        return {
          ...prev,
          [scrip]: updatedRows,
        };
      });
    }, 200);
  };

  useLayoutEffect(() => {
    let change = false;
    selectedData.forEach((row) => {
      // Only auto-populate price if it's a new row (hasn't been manually edited)
      if (symbolData[row.code] && !row.price && row.isNewRow) {
        row.price = symbolData[row.code]?.ltp;
        if (!row.price) {
          row.price = symbolData[row.code]?.prev_close;
        }
        row.isNewRow = false; // Mark as no longer new
        change = true;
      }
    });
    if (change) {
      setRows((prev) => {
        return {
          ...prev,
          [selectedSymbol?.scrip]: selectedData,
        };
      });
    }
  }, [selectedData, symbolData]);

  const computeGreeks = () => {
    const ltp = parseFloat(symbolData[selectedSymbol?.code]?.ltp);
    const riskFreeRate = 0.064515;

    const updatedSelectedData = [...selectedData];

    updatedSelectedData.forEach((item) => {
      const strike = parseFloat(item.strike);

      // Validate that we have a valid strike price and required data
      if (!isNaN(strike) && strike > 0 && item.expiry && ltp > 0) {
        const optionType = item.isCALL ? "call" : "put";
        const isCallOption = strike > ltp;
        const tempOptionType = isCallOption ? "call" : "put";

        const expiryDateTimeStr = item.expiry + " 15:29:59";
        const expiryDate = new Date(expiryDateTimeStr);
        let currentDate = new Date();
        const cutoff = new Date();
        cutoff.setHours(15, 30, 0, 0);
        if (currentDate > cutoff) {
          currentDate = cutoff;
        }

        // debugger; 
        const relevantOption = tempOptionType == "call" ? item : puts.find(put => parseFloat(put.strike) === parseFloat(item.strike));

        let timeToExpiration = Math.max(
          0.000001,
          (expiryDate - currentDate) / (24 * 60 * 60 * 365.25 * 1000) || 0.0002 / 365.25
        );

        const currentStockPrice = parseFloat(symbolData[relevantOption?.code]?.ltp);

        // Only calculate IV if we have valid option price data
        if (currentStockPrice && currentStockPrice > 0) {
          try {
            const initialGuessIv = iv.getImpliedVolatility(
              currentStockPrice,
              ltp,
              strike,
              timeToExpiration,
              riskFreeRate,
              tempOptionType
            );

            // Don't cap IV at 1 - high IV values are valid
            if (!isNaN(initialGuessIv) && initialGuessIv >= 0) {
              const ivValue = (initialGuessIv * 100).toFixed(2);
              const deltaValue = greeks
                .getDelta(
                  ltp,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  optionType
                )
                .toFixed(2);
              const thetaValue = greeks
                .getTheta(
                  ltp,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  optionType
                )
                .toFixed(2);
              const gammaValue = greeks
                .getGamma(
                  ltp,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  optionType
                )
                .toFixed(4);
              const vegaValue = greeks
                .getVega(
                  ltp,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  optionType
                )
                .toFixed(2);
              const rhoValue = greeks
                .getRho(
                  ltp,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  optionType
                )
                .toFixed(2);

              item.iv = ivValue;
              item.delta = deltaValue;
              item.theta = thetaValue;
              item.gamma = gammaValue;
              item.vega = vegaValue;
              item.rho = rhoValue;
            } else {
              // IV calculation failed - set to N/A instead of 0
              item.iv = "N/A";
              item.delta = "N/A";
              item.theta = "N/A";
              item.gamma = "N/A";
              item.vega = "N/A";
              item.rho = "N/A";
            }
          } catch (error) {
            console.warn('IV calculation failed for strike:', strike, error);
            // Set to N/A instead of 0 when calculation fails
            item.iv = "N/A";
            item.delta = "N/A";
            item.theta = "N/A";
            item.gamma = "N/A";
            item.vega = "N/A";
            item.rho = "N/A";
          }
        } else {
          // No valid option price data available
          item.iv = "N/A";
          item.delta = "N/A";
          item.theta = "N/A";
          item.gamma = "N/A";
          item.vega = "N/A";
          item.rho = "N/A";
        }
      } else {
        // Invalid or missing data - set to N/A instead of 0
        item.iv = "N/A";
        item.delta = "N/A";
        item.theta = "N/A";
        item.gamma = "N/A";
        item.vega = "N/A";
        item.rho = "N/A";
      }
    });

    setCurrentOptionsCopy(updatedSelectedData);
  };

  // useEffect(() => {
  //   handleStrategyOnSymbolChange();
  // }, [optionData]);

  useLayoutEffect(() => {
    setGreeksJson(currentOptionsCopy);
    computeGreeks();
  }, [selectedData, currentOptionsData]);

  // useLayoutEffect(() => {
  //   updateSelectedDataGreeks();
  // }, [selectedData, optionData]);

  // const updateSelectedDataGreeks = () => {
  //   selectedData.map((row, index) => {
  //     const option_index = optionData.options.findIndex(
  //       (jsonObj) => jsonObj.strike === row.strike
  //     );
  //     if (option_index != -1) {
  //       let optiondata = row.isCALL
  //         ? optionData.options[option_index].call
  //         : optionData.options[option_index].put;
  //       let delta = optiondata?.delta;
  //       let theta = optiondata?.theta;
  //       let gamma = optiondata?.gamma;
  //       let vega = optiondata?.vega;
  //       if (!row.isBuy) {
  //         delta = -delta;
  //         theta = -theta;
  //         vega = -vega;
  //         gamma = -gamma;
  //       }
  //       optiondata.delta = delta;
  //       optiondata.theta = theta;
  //       optiondata.gamma = gamma;
  //       optiondata.vega = vega;
  //     }
  //   });
  // };

  // Extracting strike
  const extractStrikeValues = (optionData) => {
    if (!optionData || !Array.isArray(optionData.options)) {
      return [];
    }
    return optionData.options?.map((options) => options?.strike);
  };

  const handleOKClick = async (isVirtual) => {
    const payload = generateOrderPayload({
      isVirtual: isVirtual,
      selectedData,
      marketType,
      limitOrderStates,
      selectedSymbol,
      broker,
      access_token,
      client_id,
      orderTypes,
      inputModes,
    });
    try {
      const response = await sendOrder(payload, isVirtual);
      // clearBasket();
      fetchBalanceAPI();
      if (response.status) {
        toast.success(
          <CustomToastContent
            heading={response.message_header}
            message={response.message_body}
          />,
          {
            className: "custom-success-toast",
            icon: <img src={SuccessIcon} alt="Success Icon" />,
            onClick: () => handleToastToNavigate(response),
          }
        );
      } else {
        toast.error(
          <CustomToastContent
            heading={response.message_header}
            message={response.message_body}
          />,
          {
            className: "custom-error-toast",
            icon: <img src={ErrorIcon} alt="Error Icon" />,
          }
        );
      }
    } catch (error) {
      console.error("Error handling order:", error);
      toast.error(
        <CustomToastContent
          heading="Error handling order"
          message={error.message}
        />,
        {
          className: "custom-error-toast",
          icon: <img src={ErrorIcon} alt="Error Icon" />,
        }
      );
    }
  };

  const [overallMargin, setOverallMargin] = useState(null);
  const [finalMargin, setFinalMargin] = useState(null);
  const [hedgeBenefits, setHedgeBenefits] = useState(null);
  const [marginRequired, setMarginRequired] = useState(null);
  const [charges, setCharges] = useState(null);
  const marginEffectRunRef = useRef(0);

  // marginRequired api call
  useLayoutEffect(() => {
    const runId = ++marginEffectRunRef.current;
    let isCancelled = false;
    const isActiveRun = () =>
      !isCancelled && marginEffectRunRef.current === runId;

    const generateMarginPayload = () => {
      const orderList = selectedData.map((currData, ind) => {
        const price =
          currData.hasOwnProperty("price") && currData.price
            ? currData.price
            : symbolData[currData.code]?.ltp;

        return {
          isBuy: currData.isBuy,
          isCall: currData.isCALL,
          isFut: false,
          code: currData.code,
          exchange: currData.exchange,
          productType: marketType === "NRML" ? "NRML" : "MIS",
          orderType: !limitOrderStates?.[selectedSymbol?.scrip]?.[ind]
            ? "MARKET"
            : "LIMIT",
          quantity: currData.lotSize * currData.lot_multiplier,
          price,
          strike: currData.strike,
          expiry: currData.expiry,
          tradingSymbol: currData.tradingSymbol,
          lot_multiplier: currData.lot_multiplier,
          scrip: currData.scrip,
        };
      });

      return {
        order_list: orderList,
        broker,
        access_token,
        client_id,
      };
    };

    const hasUndefinedPrice = (payload) =>
      payload.order_list.some((order) => order.price === undefined);

    const fetchWithRetry = async (
      requestFn,
      isDataReady,
      maxAttempts = 3,
      delayMs = 200
    ) => {
      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        try {
          const response = await requestFn();
          if (isDataReady(response?.data)) {
            return response;
          }
        } catch (error) {
          if (attempt === maxAttempts - 1) throw error;
        }
        await new Promise((resolve) => setTimeout(resolve, delayMs));
      }
      return null;
    };

    const fetchMarginRequired = async () => {
      const payload = generateMarginPayload();
      if (hasUndefinedPrice(payload)) {
        // Wait for next state update when prices are available.
        return;
      }

      try {
        const response = await fetchWithRetry(
          () =>
            axios.post(
              "https://7mwh6csmrh.execute-api.ap-south-1.amazonaws.com/default/og_allbrokers_margin",
              payload
            ),
          (data) => data?.finalMargin != null
        );
        if (!response || !isActiveRun()) {
          return;
        }
        setMarginRequired(response.data.marginRequired);
        setOverallMargin(response.data.marginAvailable);
        setFinalMargin(response.data.finalMargin);
        setHedgeBenefits(response.data.hedge_benefit);
      } catch (error) {
        console.error("Error getting margin required:", error);
      }
    };

    const fetchCharges = async () => {
      const payload = generateMarginPayload();
      if (hasUndefinedPrice(payload)) {
        // Wait for next state update when prices are available.
        return;
      }
      try {
        const response = await fetchWithRetry(
          () =>
            axios.post(
              "https://pc933vy3c6.execute-api.ap-south-1.amazonaws.com/default/og_allbrokers_charges",
              payload
            ),
          (data) => data?.total_charges != null
        );
        if (!response || !isActiveRun()) {
          return;
        }
        setCharges(response.data.total_charges);
      } catch (error) {
        console.error("Error getting charges:", error);
      }
    };

    if (selectedData.length > 0) {
      fetchMarginRequired();
      fetchCharges();
    }
    if (selectedData?.length === 0) {
      if (!isActiveRun()) {
        return;
      }
      setMarginRequired(null);
      setOverallMargin(null);
      setFinalMargin(null);
      setHedgeBenefits(null);
    }
    return () => {
      isCancelled = true;
    };
  }, [selectedData]);

  const handleAddNewRow = () => {
    if (selectedData.length === 0) {
      handleMarketTypeChange("NRML");
      const newRow = {
        isBuy: true, // Default to Buy
        expiry: "", // Default empty expiry
        strike: "", // Default empty strike
        isCALL: true, // Default to CE
        lotSize: 1, // Default lot size
        price: "",
        stoploss: "", // Default empty stoploss
        target: "", // Default empty target
      };
      const scrip = selectedSymbol.scrip;
      setRows((prev) => {
        return {
          ...prev,
          [scrip]: newRow,
        };
      });
      setData([newRow]);
      return;
    }
    let childData = applyPreBuiltStrategy("buy_call");
    handleCallback([childData], true);
  };

  const handleAddNewStrategyClick = () => {
    handleLotxChange(1);
    handleMarketTypeChange("NRML");
    let childData = applyPreBuiltStrategy("buy_call");
    handleCallback([childData], true);
  };
  const [sumGreeksValue, setSumGreeksValue] = useState({
    theta: 0,
    gamma: 0,
    delta: 0,
    vega: 0,
    rho: 0,
  });
  useEffect(() => {
    // Ensure greeksData is an array
    if (!Array.isArray(allOptionData)) {
      // console.warn("greeksData is not an array:", greeksData);
      return; // Exit early if greeksData is not an array
    }

    let theta = 0;
    let gamma = 0;
    let delta = 0;
    let vega = 0;
    let rho = 0;
    allOptionData.forEach((greek) => {
      theta += parseInt(greek.theta) || 0;
      gamma += parseFloat(greek.gamma) || 0;
      delta += parseInt(greek.delta) || 0;
      vega += parseInt(greek.vega) || 0;
      rho += parseInt(greek.rho) || 0;
    });

    gamma = gamma.toFixed(2);

    setSumGreeksValue({
      theta,
      gamma,
      delta,
      vega,
      rho,
    });
  }, [selectedData, allOptionData]);

  const showConfirmModal = () => {
    // Validate that all Limit orders have prices
    const limitOrdersWithoutPrice = selectedData.filter((row, index) => {
      const isLimitOrder = row.orderType === "L";
      const hasEmptyPrice = !row.price || row.price === "" || row.price === null;
      return isLimitOrder && hasEmptyPrice;
    });

    if (limitOrdersWithoutPrice.length > 0) {
      toast.error(
        <CustomToastContent
          heading="Price cannot be empty"
          message="Please enter a price for all Limit orders before executing."
        />,
        {
          className: "custom-error-toast",
          icon: <img src={ErrorIcon} alt="Error Icon" />,
        }
      );
      return;
    }

    setShowConfirm(true);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLtp, setCurrentLtp] = useState(null);
  const [atmIndexData, setAtmIndexData] = useState({});
  const [ltptoiv, setLtpToIv] = useState(0);

  useEffect(() => {
    if (!selectedData || selectedData.length === 0) return;
    const trySetLtp = () => {
      if (selectedSymbol?.code && symbolData[selectedSymbol.code]) {
        setCurrentLtp(symbolData[selectedSymbol?.code]?.ltp);
      } else {
        setTimeout(trySetLtp, 200);
      }
    };
    trySetLtp();
    const atmIndex = returnAtmIndex();
    const callOption =
      currentOptionsData[selectedExpiry]?.options[atmIndex]?.call;
    const ltpToIv = symbolData[callOption?.code]?.ltp;
    setLtpToIv(ltpToIv);
    setAtmIndexData(callOption);
    // console.log(callOption, "callOption", ltpToIv);
  }, [selectedData, selectedExpiry]);

  const payoffGraphProps = useMemo(
    () => ({
      newltp: currentLtp,
      newSelectedData: selectedData,
      newAtmIndex: atmIndexData,
      newLtptoIV: ltptoiv,
      newLotsVal: selectedSymbol?.lot_size,
      newStep: selectedSymbol?.step,
      newGreeksData: currentOptionsCopy,
      isPosition: false,
      isDark: theme === "dark",
      computedData: graphComputedData,
      symbolData: symbolData, // Pass symbolData for OI information
      selectedSymbol: selectedSymbol, // Pass selectedSymbol
      currentOptionsData: currentOptionsData, // Pass currentOptionsData
      selectedExpiry: selectedExpiry, // Pass selectedExpiry
    }),
    [
      currentLtp,
      selectedData,
      atmIndexData,
      ltptoiv,
      selectedSymbol?.lot_size,
      selectedSymbol?.step,
      currentOptionsCopy,
      theme,
      computedData,
      symbolData, // Add symbolData to dependencies
      selectedSymbol, // Add selectedSymbol to dependencies
      currentOptionsData, // Add currentOptionsData to dependencies
      selectedExpiry, // Add selectedExpiry to dependencies
    ]
  );

  const [objectData, setObjectData] = useState({});

  const [savedStrategies, setSavedStrategies] = useState([]);

  // Function to fetch saved strategies from API
  const fetchSavedStrategies = async () => {
    try {
      const response = await fetch(
        "https://zp4749ggcf.execute-api.ap-south-1.amazonaws.com/default/getSavedStrategies",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: client_id,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setSavedStrategies(data || []);
    } catch (err) {
      console.error("Error fetching saved strategies:", err);
    }
  };

  // Use effect to fetch saved strategies when component mounts
  useEffect(() => {
    fetchSavedStrategies();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Ensure PayoffGraph has initial data on first render after basket import
  useEffect(() => {
    // If rows exist but greeks copy hasn't populated yet, seed it so graph can render
    if (selectedData?.length > 0 && (!currentOptionsCopy || currentOptionsCopy.length === 0)) {
      setCurrentOptionsCopy(selectedData);
    }
  }, [selectedData]);

  // Parse basket from URL and populate rows
  useEffect(() => {
    try {
      const params = new URLSearchParams(location.search);
      const basketParam = params.get("basket");
      if (!basketParam || !selectedSymbol || !allOptionsData || !selectedSymbol?.option_expiries?.length) return;

      // Decode and parse JSON (supports encoded or raw JSON)
      let parsed;
      try {
        const decoded = decodeURIComponent(basketParam);
        parsed = JSON.parse(decoded);
      } catch (_) {
        try {
          parsed = JSON.parse(basketParam);
        } catch (e) {
          return;
        }
      }

      const items = Array.isArray(parsed) ? parsed : [];
      if (items.length === 0) return;

      // Helper: find matching expiry string used in app from incoming ISO
      const pickExpiryKey = (isoStr) => {
        if (!isoStr) return null;
        const targetDate = new Date(isoStr);
        // Pick from known expiries by same calendar date
        for (const exp of selectedSymbol.option_expiries) {
          const d = new Date(exp);
          if (!isNaN(d) && d.toDateString() === targetDate.toDateString()) return exp;
        }
        // Fallback: return first expiry if exact match not found
        return selectedSymbol.option_expiries[0] || null;
      };

      // Build childData array compatible with handleCallback using our option dataset
      const childRows = [];
      let firstExpiryKey = null;
      for (const it of items) {
        const expiryKey = pickExpiryKey(it.expiry);
        if (!expiryKey) continue;
        if (!firstExpiryKey) firstExpiryKey = expiryKey;
        const scripKey = selectedSymbol?.scrip;
        const expiryOptions = allOptionsData?.[scripKey]?.[expiryKey]?.options;
        if (!Array.isArray(expiryOptions) || expiryOptions.length === 0) {
          // Option data not ready yet; wait for it on next effect run
          return;
        }

        // Determine strike and option side
        const inferStrike = () => {
          const fromTs = String(it.tradingSymbol || "");
          const m = fromTs.match(/(\d+)(?!.*\d)/);
          if (m) return parseInt(m[1]);
          const fromName = String(it.formattedInsName || "");
          const m2 = fromName.match(/\b(\d{3,6})\b/);
          return m2 ? parseInt(m2[1]) : null;
        };
        const strikeVal = inferStrike();
        if (!strikeVal) continue;

        const isCall = /C(?![A-Z])|\bCE\b/i.test(it.tradingSymbol || it.formattedInsName || "");
        const isPut = /P(?![A-Z])|\bPE\b/i.test(it.tradingSymbol || it.formattedInsName || "");
        const side = isCall ? "Call" : isPut ? "Put" : null;
        if (!side) continue;

        // Lookup option row for accurate codes/lot sizing
        const row = expiryOptions.find((o) => parseInt(o?.strike) === parseInt(strikeVal));
        const leg = side === "Call" ? row?.call : row?.put;
        if (!row || !leg) continue;

        const lotsOrQty = parseInt(it.qty) || 1;
        const lotSizePerLot = parseInt(leg?.lot_size) || 1;
        // Convert total quantity to number of lots when possible
        const quantityLots = Math.max(1, Math.round(lotsOrQty / lotSizePerLot));

        childRows.push({
          buy_sell: String(it.transType).toUpperCase() === "B" ? "Buy" : "Sell",
          code: leg.code,
          expiryDate: leg.expiry_date,
          instrumentName: leg.instrument_name,
          lotSize: leg.lot_size,
          side: side,
          tradingSymbol: leg.trading_symbol,
          quantity: quantityLots,
          freeze_qty: leg.freeze_qty,
          exchange: leg.exchange,
          strike: parseInt(strikeVal),
          lot_multiplier: leg.lot_size,
          scrip: selectedSymbol?.scrip,
          price: it.price ? String(it.price) : "",
          trigger_price: it.triggerPrice ? String(it.triggerPrice) : "",
          orderType: String(it.priceType).toUpperCase() === "L" ? "L" : "M",
          isFuture: false,
        });
      }
      if (childRows.length === 0) return;
      // Ensure graph uses the correct expiry immediately
      if (firstExpiryKey && selectedExpiry !== firstExpiryKey) {
        setSelectedExpiry(firstExpiryKey);
      }
      handleCallback([childRows], false);

      // Force Greeks computation after basket population
      setTimeout(() => {
        if (selectedData?.length > 0) {
          computeGreeks();
        }
      }, 100);
    } catch (e) {
      // ignore parsing errors
    }
  }, [location.search, selectedSymbol, allOptionsData]);

  return (
    <>
      <Helmet>
        <title>Strategy Creator</title>
      </Helmet>
      <div className="grid grid-cols-8 gap-4 pt-10">
        {isOverlayActive && <div className="overlay"></div>}
        <div className="col-span-3 mt-3 mb-5">
          <Tabs />
          <div className=" flex gap-4 pt-3">
            <>
              <button
                className="create-strategy-btn btn-op"
                onClick={() => {
                  setShowOptionChainModal(true);
                  // console.log(currentOptionsData[selectedExpiry], calls);
                }}>
                <img
                  src={OcIcon}
                  alt="option-chain-icon"
                  width={16}
                  height={16}
                  style={{
                    filter:
                      theme === "dark" ? "brightness(0) invert(1)" : "none",
                  }}
                />
                Option Chain
              </button>

              <div
                className={`modal ${showOptionChainModal ? "modal-open" : ""}`}>
                <div className="modal-box p-0 max-w-[1000px] min-h-[700px] rounded-md w-full bg-modalBg no-scrollbar">
                  <div className="flex p-4 justify-between items-center">
                    {/* Left side - Instrument Toggle */}
                    <div className="flex items-center">
                      <InstrumentTypeToggle
                        selectedType={selectedInstrumentType}
                        onTypeChange={setSelectedInstrumentType}
                      />
                    </div>

                    {/* Right side - Expiry, Configure, and Close Button */}
                    <div className="flex gap-2 items-center">
                      <ExpiryDropdown
                        expiry={selectedExpiry}
                        expiries={
                          selectedInstrumentType === "Options"
                            ? selectedSymbol?.option_expiries
                            : futuresExpiries
                        }
                        onSelect={(selected) => {
                          setSelectedExpiry(selected);
                        }}
                        label="Exp:"
                      />
                      {selectedInstrumentType === "Options" && (
                        <Configure
                          configureSettingsMap={configureSettingsMap}
                          setConfigureSettingsMap={setConfigureSettingsMap}
                        />
                      )}
                      <button
                        onClick={() => {
                          setShowOptionChainModal(false);
                        }}
                        // className="p-2 rounded-full bg-p400 text-n600 border-2 border-n600 hover:bg-body flex justify-center items-center">
                        // <img
                        //   src={theme === "dark" ? CrossDark : Cross}
                        //   alt="Execute icon"
                        //   className="w-4 h-4"
                        // />
                        className="btn btn-sm bg-p400 text-n600 border-2 border-n600 hover:bg-body mr-2">
                        ✕
                      </button>
                    </div>
                  </div>

                  {selectedInstrumentType === "Options" ? (
                    !configureSettingsMap.showCalls &&
                      !configureSettingsMap.showPuts ? (
                      <div className=" w-full h-[500px] bg-p400 text-n500 rounded-md text-[14px] text-center flex justify-center items-center py-6">
                        Enable Calls or Puts to view data
                      </div>
                    ) : currentOptionsData[selectedExpiry] ? (
                      <OptionChainTable
                        handleLotxChange={handleLotxChange}
                        optionData={currentOptionsData[selectedExpiry]}
                        options={currentOptionsData[selectedExpiry]?.options}
                        showCalls={configureSettingsMap.showCalls}
                        showPuts={configureSettingsMap.showPuts}
                        calls={calls}
                        puts={puts}
                        parentCallback2={handleCallback2}
                        clickEnable={true}
                        symbol={selectedSymbol}
                        showDelta={configureSettingsMap.showDelta} //
                        showGamma={configureSettingsMap.showGamma} //
                        showVega={configureSettingsMap.showVega} //
                        showRho={configureSettingsMap.showRho} //
                        showTheta={configureSettingsMap.showTheta} //
                        showOIChng={configureSettingsMap.showOIChng} //
                        showOIBuilddup={true} //
                        isScalpOrderChecked={true}
                        maxPain={maxPain}
                        selectedDate={activeDate}
                        setObjectData={setObjectData}
                        objectData={objectData}
                        selectedData={selectedData}
                        directAddToBasket={true}
                      />
                    ) : (
                      <div>Loading data...</div>
                    )
                  ) : (
                    <>
                      <FuturesTable
                        futuresData={futuresData}
                        onFutureSelect={(future) => {
                          if (!future?.raw) return;
                          // Open modal defaulting to Buy when row clicked
                          openBuySellModalForFuture(future.raw, "Buy");
                        }}
                        onFutureBuy={(future) => {
                          if (!future?.raw) return;
                          openBuySellModalForFuture(future.raw, "Buy");
                        }}
                        onFutureSell={(future) => {
                          if (!future?.raw) return;
                          openBuySellModalForFuture(future.raw, "Sell");
                        }}
                      />
                      <BuySellModal
                        modalOpen={isBuySellModalOpen}
                        modalClose={() => setIsBuySellModalOpen(false)}
                        isOrders={false}
                        setIsBuySellModalOpen={setIsBuySellModalOpen}
                        fetchOrders={() => { }}
                        initialData={null}
                        action={modalAction}
                        handleAddToBasket={handleFuturesAddToBasket}
                        isFromCharts={false}
                      />
                    </>
                  )}
                </div>
                <div
                  className="modal-backdrop"
                  onClick={() => setShowOptionChainModal(false)}
                />
              </div>
            </>

            <button
              className="create-strategy-btn btn-screener"
              onClick={() => setIsModalOpen(true)}>
              <img
                src={AutoFindIcon}
                alt="auto-find-icon"
                width={16}
                height={16}
                style={{
                  filter: theme === "dark" ? "brightness(0) invert(1)" : "none",
                }}
              />
              Auto find
            </button>
            <ScreenerModal
              parentCallback={handleScreenerback}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
            />
          </div>

          {/* Limit Risk Button - shown only when there's unlimited max loss */}
          {hasUnlimitedMaxLoss && selectedData && selectedData.length > 0 && (
            <div className="mt-4 mb-4">
              <div className={`p-4 rounded-lg border ${theme === "dark" ? "bg-p400 border-n200" : "bg-white border-n100"}`}>
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h3 className={`text-[14px] font-medium ${theme === "dark" ? "text-p300" : "text-p200"}`}>
                      Your strategy has unlimited risk
                    </h3>
                  </div>
                  <button
                    onClick={addHedge}
                    className="ml-4 text-[12px] px-6 py-2 bg-swipe-button text-p400 rounded flex gap-2"
                  >
                    Limit now
                  </button>
                </div>
              </div>
            </div>
          )}

          <Basket
            currentRows={selectedData}
            handleAddNewRow={handleAddNewRow}
            handleAddNewStrategyClick={handleAddNewStrategyClick}
            charges={charges}
            showConfirmModal={showConfirmModal}
            computedData={computedData}
            orderTypes={orderTypes}
            inputModes={inputModes}
            onOrderTypesChange={setOrderTypes}
            onInputModesChange={setInputModes}
          />
          <ConfirmStrategyModal
            isOpen={showConfirm}
            onCancel={() => setShowConfirm(false)}
            onConfirm={() => {
              setShowConfirm(false);
              handleOKClick(broker == "aliceblue" ? false : true);
            }}
          />
          <MarginAndFundsCard
            marginRequired={marginRequired}
            finalMargin={finalMargin}
            hedgeBenefits={hedgeBenefits}
            marginAvailable={fundsData.marginAvailable}
            formatNumberWithCommasAndFontWeight={
              formatNumberWithCommasAndFontWeight
            }
          />

          <PrebuiltStrategies
            strategies={strategies}
            activeCategory={
              symbolsActiveCategory[selectedSymbol?.scrip] || "bullish"
            }
            setActiveCategory={setActiveCategory}
            selectedStrategy={
              symbolsSelectedStrategy[selectedSymbol?.scrip] || null
            }
            handleStrategySelect={handleStrategySelect}
            savedStrategies={savedStrategies}
            setSavedStrategies={setSavedStrategies}
            handleCallback={handleCallback}
            scrollToTop={scrollToTop}
          />
        </div>
        <div className="col-span-5 mt-4 mb-5">
          <HedgeStratgiesContainer
            activeCategory={
              symbolsActiveCategory[selectedSymbol?.scrip] || "bullish"
            }
            onStrategySelect={handleHedgeStrategySelect}
            scrollToTop={scrollToTop}
          />
          <div className="text-[14px] text-p300 font-semibold pb-[10px]">
            Payoff Simulations
          </div>
          <StrategyMenu data={computedData} />
          {selectedData?.length > 0 &&
            currentOptionsCopy?.length > 0 ? (
            <div className="mt-4">
              <PayoffGraph {...payoffGraphProps} />
            </div>
          ) : (
            <div className="mt-4 bg-p400 rounded-md shadow-sm min-h-[500px] flex justify-center items-center">
              Please add an instrument to view the graphical analysis.
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default StrategyCreatorDesktop;
